import { GET_USER_INFO } from "@apiUtils";
import { hasAuthToken, mutationFetch } from "@atlas/sdk";
import type { IUserInfo } from "@models";
import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";

export const USER_INFO_KEY = "userInfoKey";

export const getUserInfoKey = (basePath?: string) =>
  [USER_INFO_KEY, basePath] as const;

export const useUserInfo = (
  basePath?: string,
  options?: Partial<
    UseQueryOptions<
      IUserInfo,
      AxiosError,
      IUserInfo,
      ReturnType<typeof getUserInfoKey>
    >
  >,
) => {
  return useQuery({
    queryKey: getUserInfoKey(basePath),
    queryFn: async () => {
      const url = basePath
        ? `${basePath.replace(/\/$/, "")}${GET_USER_INFO}`
        : GET_USER_INFO;
      const data = await mutationFetch<IUserInfo>({
        url,
        method: "GET",
      });
      sessionStorage.setItem("userId", data.loginId);
      return data;
    },
    ...options,
    enabled: hasAuthToken() && (options?.enabled ?? true),
  });
};
